<template>
  <div></div>
<!--  <footer class="p-footer w-100 bg-white d-block">-->
<!--    &lt;!&ndash;<p v-if="type==='cadvFoot'" class="qiang-p color-88 font-12 mb-0 w-100 text-center py-1">&ndash;&gt;-->
<!--    &lt;!&ndash;限时抢购优惠活动还剩12小时12分12秒&ndash;&gt;-->
<!--    &lt;!&ndash;</p>&ndash;&gt;-->
<!--    &lt;!&ndash;<p v-if="type==='zlFoot'" class="qiang-p font-12 color-88 mb-0 w-100 text-center py-1">&ndash;&gt;-->
<!--    &lt;!&ndash;限时优惠<span class="color-base">3天</span>后结束&ndash;&gt;-->
<!--    &lt;!&ndash;</p>&ndash;&gt;-->
<!--    <div v-if="type==='cadvFoot'">-->

<!--      <div class="p-footer-contet bottom-fixed d-flex justify-content-between align-items-center">-->
<!--        &lt;!&ndash; 课程 但是套餐 &ndash;&gt;-->
<!--&lt;!&ndash;        <div class="w-100 text-primary font-18 d-flex justify-content-center align-items-center"&ndash;&gt;-->
<!--&lt;!&ndash;             v-if="!isProjectCourse && item.payment === 'solely'">&ndash;&gt;-->
<!--&lt;!&ndash;          课程暂不出售&ndash;&gt;-->
<!--&lt;!&ndash;        </div>&ndash;&gt;-->
<!--&lt;!&ndash;        <div class="w-100 text-primary font-18 d-flex justify-content-center align-items-center"&ndash;&gt;-->
<!--&lt;!&ndash;             v-if="item.userCourse && !item.userCourse.available">&ndash;&gt;-->
<!--&lt;!&ndash;          您已被拒绝访问&ndash;&gt;-->
<!--&lt;!&ndash;        </div>&ndash;&gt;-->
<!--        &lt;!&ndash; v-else 课程 & 项目课程 显示 项目配置的价格 &ndash;&gt;-->
<!--        <div class="w-100 h-100 d-flex">-->
<!--          &lt;!&ndash;项目课程是显示划线标灰价格，右侧加入学习 &ndash;&gt;-->
<!--          <div v-if="isHasCourse" class="p-btns d-flex justify-content-start h-100 align-items-center">-->
<!--            <div class="yuan ml-4 mr-2 font-22" v-if="item.free">-->
<!--              免费-->
<!--            </div>-->
<!--            <div class="yuan ml-4 mr-2 font-22" v-else>-->
<!--              ¥ {{item.price}}-->
<!--            </div>-->
<!--          </div>-->
<!--          &lt;!&ndash;课程是显示蓝色价格，右侧购买 &ndash;&gt;-->
<!--          <div v-if="!isHasCourse" class="p-btns d-flex justify-content-start h-100 align-items-center">-->
<!--            <div class="price ml-4 mr-2" v-if="item.payment === 'free'">-->
<!--              免费-->
<!--            </div>-->
<!--            <div class="price ml-4 mr-2" v-else>-->
<!--              ¥ {{item.currentPrice}}-->
<!--            </div>-->
<!--            <div class="d-flex flex-column" v-if="item.originalPrice > item.currentPrice">-->
<!--              <span class="xian">限时</span>-->
<!--              <span class="yuan">¥ {{item.originalPrice}}</span>-->
<!--            </div>-->
<!--          </div>-->

<!--          <div class="h-100 p-bm-btn">-->
<!--            <div class="text-white" @click="showDialog">-->
<!--              {{(item.currentPrice === 0 ||item.payment === 'free' )?'学习':'购买'}}-->
<!--            </div>-->
<!--            &lt;!&ndash;        <a v-if="type==='zlFoot'" class="text-white" href="#">立即加入</a>&ndash;&gt;-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->

<!--    </div>-->

<!--  </footer>-->
</template>

<script>
  import Vue from 'vue';
  import { Dialog } from 'vant';
  Vue.use(Dialog);
  export default {
    name: "payFooter",
    props: [
      'type',
      'item', //传入的是项目课程 或者 课程
      'isProjectCourse',
      'isHasCourse'  //true: 只有项目课程时才存在true现象  false: 是课程时
    ],
    data() {
      return {

      }
    },
    created() {

    },
    mounted() {

    },
    methods:{
    }
  }
</script>

<style scoped>
.dialog-div {
  width: 80%;
  height: 200px;
}
</style>
